import { mount } from 'svelte';
import App from './ui/App.svelte';
import { installSelectionGuards } from './ui/noSelect';
import './theme/tokens.css';

installSelectionGuards();
const app = mount(App, { target: document.getElementById('app')! });
export default app;
